import { all } from 'redux-saga/effects';

import leaveBalanceSagaWatcher from './employeeLeaveBalanceSaga';

export default function* rootSaga(action) {
	yield all([leaveBalanceSagaWatcher(action)]);
}
